<template>
    <div id="app-component">
        <div v-if="$route.name === 'encounter' || $route.name === 'patientFoodTestSurvey'
         || $route.name === 'patientRosQuestionnaire' || $route.name === 'patientRequestConsent'
         || $route.name === 'patientVitalSign'">
            <router-view :key="$route.name"></router-view>
        </div>
        <div v-else>
            <TopHeader/>
            <div v-if="$store.state.authenticated && $route.name !== 'login'" class="content container">
                <div class="maincontent">
                    <Navigator/>
                    <div style="clear:both"></div>
                    <div class="editproviewport blockcont skintestblock">
                        <router-view :key="$route.name"></router-view>
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="not-login">
                    <router-view :key="$route.name"></router-view>
                </div>
            </div>
        </div>

        <modal v-model="modalInactivity" @show="showModal" @hide="hideModal" classes="skintestblock" :backdrop="false"
               :dismiss-btn="false">
            <h4 slot="title" class="smalltitle">Inactivity</h4>

            <div class="profield fullw">
                Immunotherapy module is about to signed out due to inactivity. Please continue to use or WikiAllergies
                will stop
                your session.
            </div>
            <div class="profield fullw number-count-down" v-if="countDown > 0">
                <span>{{countDown}}</span>
            </div>
            <div slot="footer">
                <button type="button" class="btn btn-default" @click="proceedRequest">Proceed</button>
                <button type="button" class="btn btn-default" @click="cancelRequest">Cancel</button>
            </div>
        </modal>

        <modal id="modalAlertMessage" v-model="$store.state.alertMessage.open" class="skintestblock" append-to-body :dismiss-btn="false" @hide="hideModalAlert">
            <h4 slot="title" class="smalltitle">{{$store.state.alertMessage.title}}</h4>
            <div class="profield fullw" :class="{errorMessage : ($store.state.alertMessage.type == 'error')}" v-html="$store.state.alertMessage.msg">
            </div>
            <div slot="footer"><button type="button" class="btn btn-default" @click="closeModalMessage">Close</button></div>
        </modal>

        <div class="loading" v-show="showLoadingScreen">
            <div class="loadingblock">
                <div class="loadingmessage">
                    <div class="bigtext"><i class="fas fa-spinner fa-spin"></i>Loading...</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TopHeader from '@/components/Header.vue'
import Navigator from '@/components/Navigator.vue'
import axios from './client'
import { mapGetters } from 'vuex'

export default {
  name: 'home',
  components: {
    TopHeader,
    Navigator
  },
  data () {
    return {
      user: {},
      countDown: 60,
      clearInternal: null,
      clearAlertMessage: null
    }
  },
  createdAt () {
  },
  mounted () {
    if (this.$store.state.isFullScreen) {
      document.body.className = 'fullscreen'
    }
  },
  destroyed () {
    clearTimeout(this.clearAlertMessage)
  },

  methods: {
    hideModalAlert () {
      if (this.$store.state.alertMessage.msg === 'You do not have permission to access this patient') {
        window.location.href = '/'
      }
    },
    closeModalMessage () {
      if (this.$store.state.alertMessage.msg === 'You do not have permission to access this patient') {
        window.location.href = '/'
      }
      this.$store.commit('setAlertMessage', { type: '', title: '', open: false, msg: '' })
    },
    showModal () {
      let vm = this
      vm.countDown = 60
      clearInterval(this.clearInternal)
      this.clearInternal = setInterval(function () {
        if (vm.countDown === 1) {
          vm.$store.commit('setOpenModalLogin', false)
          vm.$router.replace({ name: 'login' })
          clearInterval(vm.clearInternal)
        }
        vm.countDown--
      }, 1000)
    },
    hideModal () {
      clearInterval(this.clearInternal)
      if (!this.$store.state.authenticated) {
        this.$router.replace({ name: 'login' })
      }
    },
    cancelRequest () {
      this.$store.commit('setOpenModalLogin', false)
      this.$router.replace({ name: 'login' })
    },
    proceedRequest () {
      axios.post(`/refresh-token/`).then(response => {
        this.$store.commit('setOpenModalLogin', false)
        if (response.data.s === 200) {
        } else {
          this.$router.replace({ name: 'login' })
        }
      }).catch(e => {
        this.$store.commit('setOpenModalLogin', false)
        this.$router.replace({ name: 'login' })
      })
    }
  },
  computed: {
    ...mapGetters({
      storeAuthenticated: 'authenticated',
      storeUserPermissions: 'userPermissions'
    }),
    modalInactivity () {
      return this.$store.state.openModalLogin // return loggedIn from vuex
    },
    modalAlert () {
      return this.$store.state.alertMessage.open
    },
    showLoadingScreen () {
      return this.$store.state.showLoadingScreen
    }
  },
  watch: {
    // force logout when other tab logout with multi share state authenticated
    storeAuthenticated (newVal, oldVal) {
      if (!newVal && this.$router.name !== 'login') {
        this.$router.replace({ name: `login` })
      }
    },
    modalAlert (newValue, oldValue) {
      if (newValue) {
        let vm = this
        this.clearAlertMessage = setTimeout(function () {
          vm.$store.commit('setAlertMessage', { type: '', title: '', open: false, msg: '' })
        }, 20000)
      } else {
        clearTimeout(this.clearAlertMessage)
      }
    }

  }
}
</script>
<style>
    body {
        overflow-x: hidden;
    }
    textarea:disabled {
        background: #efefef;
    }
    .loadingblock {
        /*width: 320px;*/
        /*height: 100px;*/
        /*padding: 25px 30px;*/
        /*background: #fff;*/
        /*border: 1px solid #e1e1e1;*/
        position: absolute;
        top: 50%;
        left: 50%;
    }

    .loader {
        width: 50px;
        height: 50px;
        /*background: url({{ url('/thuy/images/loader.gif') }}) no-repeat center;*/
        float: left;
        margin-right: 15px;
    }

    .loadingmessage {
        float: left;
        font-size: 14px;
        font-family: Montserrat, Arial, Helvetica, sans-serif;
    }

    .loadingmessage .bigtext {
        font-size: 22px;
    }

    .modal-header .close {
        top: 10px !important;
    }

    input[type=number]::-webkit-inner-spin-button,
    input[type=number]::-webkit-outer-spin-button {
        -webkit-appearance: none;
        -moz-appearance: none;
        margin: 0;
    }

    .lock-question-screen .modal-backdrop {
        background-color: black;
        opacity: 1 !important;
    }

    .checkout-bill {
        color: #39ab71 !important;
    }

    /*//override color checkin checkout */
    .apt-list > li.checkout > div:first-child {
        color: #39ab71 !important;
    }

    .apt-list > li.checkin > div:first-child {
        color: #496dc9 !important;
    }

    .loading-screen {
        text-align: center;
        color: #d9df20;
        font-size: 16pt
    }

    .modal-header .close {
        position: absolute !important;
    }

    /*//css for bill appointment*/
    .appointment-color.noshow {
        color: #d44c39;
    }

    .appointment-color.checkin {
        color: #496dc9 !important;
    }

    .appointment-color.checkout {
        color: #39ab71 !important;
    }

    .appointment-color.reschedule {
        color: #ee9731 !important;
    }

    .appointment-color.cancel {
        color: #aa5198 !important;
    }
    .dropdown-menu {
        z-index: 9999999999999;
    }
    .dropdown-menu > div > a {
        display: block;
        padding: 3px 20px;
        clear: both;
        font-weight: 400;
        line-height: 1.42857143;
        color: #333;
        white-space: nowrap;
        cursor: pointer;
    }

    .icon-order-biologic {
        background-image: url("../public/img/orderBio.png");
        background-size: cover;
        width: 12px;
        height: 13px;
        display: inline-block;
    }

    .errorMessage {
        color: red;
        font-size: 18px;
    }
    select > option  {
        text-align: left;
    }
</style>
<style scoped>
    .number-count-down {
        text-align: center;
        font-size: 40px;
        font-weight: bold;
    }

    #modalAlertMessage {
        z-index: 999999999999999999 !important;
    }

</style>
